import { render, staticRenderFns } from "./givingCredits.vue?vue&type=template&id=08aa927e&scoped=true&"
import script from "./givingCredits.vue?vue&type=script&lang=js&"
export * from "./givingCredits.vue?vue&type=script&lang=js&"
import style0 from "./givingCredits.vue?vue&type=style&index=0&id=08aa927e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aa927e",
  null
  
)

export default component.exports